import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createExchangeOrder, getIsLoadingByType } from '@entities/exchange';
export function useCreateExchange() {
    const dispatch = useDispatch();
    const isLoading = useSelector(getIsLoadingByType('create-exchange'));
    const onCreateExchange = useCallback((payload) => {
        dispatch(createExchangeOrder(payload));
    }, [dispatch]);
    return { onCreateExchange, isLoading };
}
